<template>
  <el-dialog class="chooseHandller" title="选择处理人员" :visible.sync="chooseHandlerVisible" width="400px" :show-close="true" :close-on-click-modal="false" :before-close="handleClose">
    <div class="content bg-f3f4f7">
      <div class="flex mtb-10 plr-20">
        <div class="flex flex-1 align-center bg-ff h-30 border-e2 border-ra search">
          <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
          <el-input type="text" placeholder="输入关键字" v-model="keywords" clearable @keyup.enter.native="searchBtn"></el-input>
        </div>
        <button class="btn-30-bg-82b925" @click="searchBtn">搜索</button>
      </div>
      <div style="padding:5px 20px;" class="bg-ff text-left flex align--center" v-if="selectedList.length > 0">
        <div class="font-12-30313a">已选人员：</div>
        <div class="font-12-ff5555">{{projectMemberStr}}</div>
      </div>
      <div class="list-main text-left">
        <div class="flex-column cursor" v-for="(item, index) in projectMember" :key="index">
          <div class="bg-f3f4f7 font-bold" style="padding:5px 20px;">{{item.name}}</div>
          <div class="flex align-center item bg-ff" v-for="(personItem, i) in item.employeeList" :key="i" @click="onCheck(personItem.id, personItem.name, personItem.telephone)">
            <img :src="isCheck(personItem.telephone) !== -1 ? '../../static/images/xuanzhong.png' : '../../static/images/weixuan.png'" class="mr-5" alt="">
            <div class="w-100">{{personItem.roleName}}</div>
            <div class="mr-10">{{personItem.name}}</div>
            <div>{{personItem.telephone}}</div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="btn-30-border-f5971d-s mr-10" @click="onReset">重置</div>
      <div class="btn-30-bg-f5971d-s" @click="onSubmit">确定</div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'ChooseHandler',
  components: {},
  props: ['id', 'flag', 'handleId'],
  data () {
    return {
      chooseHandlerVisible: false,
      keywords: null,
      projectMember: [],
      projectMemberStr: '',
      selectedList: [],
      beforeArr: [],
      beforeStr: ''
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    getProjectMember () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customerAssignRecord/getProjectMember`, {
        customerId: this.id,
        keywords: this.keywords
      }).then(res => {
        if (res.data.success) {
          this.projectMember = res.data.data
        }
      })
    },
    onCheck (id, name, telephone) {
      const that = this
      let item = {
        employeeId: id,
        name: name,
        telephone: telephone === null ? '' : telephone,
        handleId: this.handleId
      }
      if (that.isCheck(telephone) !== -1) {
        this.selectedList.splice(this.isCheck(telephone), 1)
      } else {
        this.selectedList.push(item)
      }
      let arr = []
      this.selectedList.forEach(i => {
        arr.push(i.name)
      })
      this.projectMemberStr = arr.join('、')
    },
    isCheck (telephone) {
      let index = -1
      for (let i = 0; i < this.selectedList.length; i++) {
        if (this.selectedList[i].telephone === telephone) {
          index = i
          break
        }
      }
      return index
    },
    handleClose () {
      this.selectedList = this.Utils.deepClone(this.beforeArr)
      this.projectMemberStr = this.beforeStr
      this.chooseHandlerVisible = false
    },
    searchBtn () {
      this.getProjectMember()
    },
    onReset () {
      this.beforeArr = []
      this.selectedList = []
      this.beforeStr = ''
      this.projectMemberStr = ''
      this.$parent.$parent.add.handlerParamList = this.Utils.deepClone(this.selectedList)
      this.$parent.$parent.projectMemberStr = this.projectMemberStr
    },
    onSubmit () {
      if (!this.flag) {
        this.$parent.$parent.add.handlerParamList = this.Utils.deepClone(this.selectedList)
        this.$parent.$parent.projectMemberStr = this.projectMemberStr
        this.chooseHandlerVisible = false
      } else {
        if (this.selectedList.length === 0) {
          this.$message({
            message: '请选择处理人员！',
            type: 'warning'
          })
        } else {
          this.axios.post(`${this.$store.state.API_URL_9010}/customerHandleHandler/modify`, this.selectedList).then(res => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success'
              })
              this.$parent.$parent.getHandleList()
              this.onReset()
              this.chooseHandlerVisible = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      }
    }
  },
  watch: {
    chooseHandlerVisible (val) {
      if (val === true) {
        this.beforeArr = this.Utils.deepClone(this.selectedList)
        this.beforeStr = this.projectMemberStr
      }
    },
    keywords (val) {
      if (val === '') {
        this.getProjectMember()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .chooseHandller /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
  .list-main{
    height: 220px;
    overflow-y: auto;
  }
  .item{
    border-bottom: 1px dashed #e2e2e2;
    padding: 3px 20px;
  }
  .item:last-child{
    border-bottom: none;
  }
  .bottom{
    border-top: 1px solid #e2e2e2;
    padding: 4px 0;
  }
  .w-100{
    width: 100px;
  }
  .search {
    overflow: hidden;
    margin-right: 10px;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/components/ChooseHandler.vue